import { render, staticRenderFns } from "./companyCard.vue?vue&type=template&id=3f705cbd&scoped=true&"
import script from "./companyCard.vue?vue&type=script&lang=js&"
export * from "./companyCard.vue?vue&type=script&lang=js&"
import style0 from "./companyCard.vue?vue&type=style&index=0&id=3f705cbd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f705cbd",
  null
  
)

export default component.exports